//@flow
import * as React from 'react';
import { themr } from 'react-css-themr';
import { Flex } from '@locus-taxy/neo-ui';
import {
    RadioGroup,
    RadioButton
} from 'common/components/core/form/RadioButton';
import { FormField } from 'common/components/core/form/FormField';
import { translate } from 'react-i18next';
import compose from 'recompose/compose';
import { withRouter } from 'common/components/core/router';
import defaultTheme from './SchedulingConfigRadioGroup.scss';
import { dashboardColors } from 'common/enums/ColorEnum';

const SchedulingConfigRadioGroup = props => {
    const {
        theme,
        selectedConfigId,
        onSchedulingConfigIdChange,
        t,
        schedulingConfigs,
        disabled
    } = props;

    return (
        <FormField
            theme={theme}
            label={t('pjpCreate.pjpConfig.configurationType')}
        >
            <RadioGroup
                className={theme.radioList}
                onChange={onSchedulingConfigIdChange}
                value={selectedConfigId}
                theme={theme}
                disabled={disabled}
            >
                {schedulingConfigs
                    ? schedulingConfigs.map(schedulingConfig => {
                          const label = (
                              <Flex
                                  flexDirection={Flex.Direction.Column}
                                  className={theme.radioLabel}
                              >
                                  <div className={theme.label}>
                                      {schedulingConfig.label}
                                  </div>
                                  <div className={theme.description}>
                                      {schedulingConfig.description}
                                  </div>
                              </Flex>
                          );
                          return (
                              <RadioButton
                                  key={schedulingConfig.id}
                                  theme={theme}
                                  label={label}
                                  value={schedulingConfig.id}
                                  radioColor={dashboardColors.darkSkyBlue.name}
                              />
                          );
                      })
                    : null}
            </RadioGroup>
        </FormField>
    );
};

const EnhancedSchedulingConfigRadioGroup = compose(
    withRouter,
    translate('entityManagement'),
    themr('SchedulingConfigRadioGroup', defaultTheme)
)(SchedulingConfigRadioGroup);

export { EnhancedSchedulingConfigRadioGroup as SchedulingConfigRadioGroup };
export default EnhancedSchedulingConfigRadioGroup;
